import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'

import './catering-menu.scss'
import { updateNodeFuctionalText, updateNodeFunctionalLevel } from 'redux/actions'

function CateringMenu() {
  const {cateringDepartmentTree} = useSelector(s => s.cateringAndMeal)
    
  const {departmentSlug} = useParams()
  
  let nodes = cateringDepartmentTree?.find(i => i.slug === departmentSlug)?.node
  const dispatch = useDispatch()
  const navigate = useNavigate()

  if (!nodes) {
    nodes = cateringDepartmentTree.map(i => ({
      category_ids: i.category_ids || i.slug,
      text: i.text,
      image: i.image,
    }))
  }

  function handleClick(node) {
    if (node.is_mealkit > 0) {
      dispatch(updateNodeFuctionalText(node?.text));
      dispatch(updateNodeFunctionalLevel(node?.funtional_level));
    }
    if (departmentSlug) {
      navigate(`?category_ids=${node.category_ids}`)
    } else {
      navigate(`/catering-meal/${node.category_ids}`)
    }
  }

  if (nodes?.length === 1) {
    handleClick(nodes[0])
  }

  return (
    <>
      <div className='catering-menu-wrapper'>
        <div className='products'>
          <div className='product-list'>
            {nodes?.map(node => {
              return (
                <div className='product-card-item' key={node.category_ids} onClick={() => handleClick(node)}>
                  <div className='product-image'>
                    <img src={node.image} className='img-wrap' alt={node.text} />
                  </div>
                  <div className='product-desc'>
                    <h4>{node.text}</h4>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}
export default CateringMenu
